import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { Title } from '@jupi/ui'
import PepeMemorial from './PepeMemorial'

// Pre-flight briefing links, as webplan's links page had them, in groups.
const GROUPS = [
  {
    key: 'weather',
    links: [
      { key: 'weather', icon: 'mdi:weather-partly-cloudy', href: 'https://www.ilmailusaa.fi/#id=rrpt#map=southern-finland#level=FL50' },
      { key: 'orbifly', icon: 'mdi:map-marker-radius-outline', href: 'https://www.orbifly.com/member/metmap.php?region_choose=SCD&mode=metar&lang=ENG&view_color=metars' },
      { key: 'tutka', icon: 'mdi:radar', href: 'https://tutka.meteo.fi/' },
      { key: 'ogimet', icon: 'mdi:weather-cloudy', href: 'https://ogimet.com/' },
      { key: 'avimet', icon: 'mdi:weather-windy', href: 'https://avimet.weatherproof.fi/avimet/' },
      { key: 'atisGuru', icon: 'mdi:radio-tower', href: 'https://atis.guru/' },
    ],
  },
  {
    key: 'planning',
    links: [
      { key: 'bulletins', icon: 'mdi:bullhorn-outline', href: 'https://www.ais.fi/bulletins/' },
      { key: 'aip', icon: 'mdi:book-open-variant', href: 'https://www.ais.fi/eaip/' },
      { key: 'ans', icon: 'mdi:airport', href: 'https://ais.fi/' },
      { key: 'ansEe', icon: 'mdi:airport', href: 'https://aim.eans.ee/en' },
      { key: 'fplSend', icon: 'mdi:send-outline', href: 'https://www.ais.fi/user/auth/login?logout=true&callbackUrl=/fi/user/submit-flight-plan/' },
      { key: 'fintrafficSky', icon: 'mdi:airplane-marker', href: 'https://sky.fintraffic.fi/' },
      { key: 'fintrafficDataSources', icon: 'mdi:database-outline', href: 'https://sky.fintraffic.fi/Information/DataSources' },
      { key: 'prepareFlights', icon: 'mdi:airplane-takeoff', href: 'https://app.prepare.flights/' },
      { key: 'flyk', icon: 'mdi:map-search-outline', href: 'https://www.flyk.com/' },
      { key: 'lentopaikat', icon: 'mdi:airport', href: 'https://lentopaikat.fi/' },
    ],
  },
  {
    key: 'efhv',
    links: [
      // EFHV's anemometer is published only as images, so it is linked, not shown.
      { key: 'efhv', icon: 'mdi:windsock', href: 'https://efhv.fi/' },
      { key: 'efhvPpr', icon: 'mdi:file-document-edit-outline', href: 'https://ppr.yleisilmailu.fi/ui/efhv/request' },
      { key: 'efhvYleisilmailu', icon: 'mdi:web', href: 'https://efhv.yleisilmailu.fi' },
      { key: 'efhvLentopaikat', icon: 'mdi:information-outline', href: 'https://lentopaikat.fi/hyvinkaa-efhv/' },
    ],
  },
] as const

export default function LinksPage() {
  const { t } = useTranslation()
  return (
    <Box>
      <Title label={t('plan.links.title')} />
      {GROUPS.map((group) => (
        <Box key={group.key} sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" component="h2" sx={{ mb: 0.5, px: 0.5 }}>
            {t(`plan.links.groups.${group.key}`)}
          </Typography>
          <Card>
            <List disablePadding>
              {group.links.map((link) => (
                <ListItemButton key={link.key} component="a" href={link.href} target="_blank" rel="noreferrer" sx={{ minHeight: 56 }}>
                  <ListItemIcon>
                    <Icon icon={link.icon} width={24} />
                  </ListItemIcon>
                  <ListItemText primary={t(`plan.links.${link.key}`)} secondary={new URL(link.href).hostname} />
                  <Icon icon="mdi:open-in-new" />
                </ListItemButton>
              ))}
            </List>
          </Card>
        </Box>
      ))}
      <PepeMemorial />
    </Box>
  )
}
